import { SerializedInteraction } from '@bluejlegal/interactions';
import { BlueJApi } from '../../core/api/blue-j-api';

type TextInput = {
  kind: 'text';
  value: string;
};

type RetryInput = {
  kind: 'retry';
  errorInteractionId: string;
}

type SubmitJobInput = TextInput | RetryInput;
type RootEntityType = 'thread';

export type SubmitJobPayload = {
  rootEntityId: string;
  rootEntityType: RootEntityType;
  input: SubmitJobInput;
};

type SubmitJobResponse = {
  jobId: string;
};

type AbortJobPayload = {
  jobId: string;
};

type InteractionSnapshotParams = {
  rootEntityId: string;
  type: 'thread';
}

export class InteractionsApi extends BlueJApi {
  private basePath = 'api/v2'

  private _submitJob = this.createFetch<SubmitJobPayload, SubmitJobResponse, void>(`${this.basePath}/ask/submit`, 'POST');
  private _abortJob = this.createFetch<AbortJobPayload, void, void>(`${this.basePath}/ask/abort`, 'POST');
  private _getInteractionSnapshot = this.createFetch<void, SerializedInteraction[], InteractionSnapshotParams>(params => `${this.basePath}/ask/interaction/${params.rootEntityId}?type=${params.type}`, 'GET');

  public async submitJob(payload: SubmitJobPayload): Promise<SubmitJobResponse> {
    return this._submitJob(payload).parsedResponse();
  }

  public async abortJob(payload: AbortJobPayload): Promise<void> {
    return this._abortJob(payload).parsedResponse();
  }

  public async getInteractionSnapshot(rootEntityId: string, type: 'thread') {
    return this._getInteractionSnapshot(undefined, { rootEntityId, type }).parsedResponse();
  }
}
